import React from "react";

const RequiredAsterisk = () => {
  return <sup className="text-danger">*</sup>;
};

const Label = ({ required = false, htmlFor = "", children }) => {
  return (
    <label htmlFor={htmlFor} style={LabelStyle}>
      {children}
      {required && <RequiredAsterisk />}:
    </label>
  );
};

export default Label;

const LabelStyle = {
  marginBottom: "0.125rem",
  fontSize: "0.9rem",
  fontWeight: "700",
};
